<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="'演练报警' | translateTo(i18nPath)"
    width="55vw"
    class="device-analog-alarm"
  >
    <MForm
      ref="form"
      class="dispose-form"
      :i18nPath="i18nPath"
      :config="config"
      :data-source="dataSource"
      :model="model"
      :rules="rules"
    ></MForm>

    <div class="actions">
      <el-button type="warning" @click="start">{{ '开始报警' | translateTo(i18nPath) }}</el-button>
      <el-button type="success" @click="stop">{{ '结束报警' | translateTo(i18nPath) }}</el-button>
      <el-button @click="handleClose">{{ '取消' | translateTo(i18nPath) }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isFunction } from '@/utils/is';
import MForm from '@/components/form/index.vue';
import { setDeviceAnalogAlarm } from '@/api/query';
import { awaitTo } from '@/utils/utils';

const dict = {
  1: '数值报警',
  1101: '烟雾报警',
  2101: '生物因子报警',
  3101: '有毒有害气体报警',
  4101: '化学战剂报警',
  7101: '核报警',
  3203: '一氧化碳报警',
  3201: '氨气报警',
  3202: '氯气报警'
};

export default {
  components: {
    MForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    const options = {
      RG05: [1],
      'FCBR-100': [1101, 2101, 3101, 4101, 3203],
      'FCBR-100PRO': [1101, 2101, 3101, 4101, 7101, 3203, 3201, 3202]
    }[this.deviceType];
    return {
      i18nPath: 'layout',
      loading: false,
      config: {
        labelWidth: 'auto',
        span: 24,
        options: [
          {
            type: 'radioGroup',
            prop: 'alarmType',
            dataKey: 'alarmTypeOptions',
            label: '报警种类'
          }
        ]
      },
      model: {
        alarmType: options?.[0]
      },
      dataSource: {
        alarmTypeOptions: options.map(e => ({ label: dict[e], value: e }))
      },
      rules: {
        alarmType: [{ required: true, message: '请选择报警类型', trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      isFunction(done) && done();
    },
    clearLoading() {
      const timer = setTimeout(() => {
        this.loading = false;
        this.confirmLoading = false;
        clearTimeout(timer);
      }, 500);
    },
    async start() {
      const [err] = await awaitTo(
        setDeviceAnalogAlarm({
          sn: this.sn,
          alarmType: this.model.alarmType,
          alarmStatus: 1
        })
      );

      if (err) {
        this.$message.warning('启用报警失败，请重试');
      } else {
        this.$message.success('启用报警成功');
      }
    },
    async stop() {
      const [err] = await awaitTo(
        setDeviceAnalogAlarm({
          sn: this.sn,
          alarmType: this.model.alarmType,
          alarmStatus: 2
        })
      );

      if (err) {
        this.$message.warning('停止报警失败，请重试');
      } else {
        this.$message.success('停止报警成功');
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.device-analog-alarm {
  .actions {
    display: flex;
    justify-content: flex-end;
  }

  .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
